import { AccreditedBuilderState } from "./types";

export const defaultState = (): AccreditedBuilderState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    accreditedBuilders: [],
    links: {}
  };
};

export const state = defaultState();
